import React from "react";
import "./Navbar.scss"
import { useSelector } from "react-redux";
import insta from "../../assets/insta.svg"
import fb from "../../assets/fb.svg"
import pin from "../../assets/pin.svg"
import tt from "../../assets/tiktok.svg"
import phone from "../../assets/mobile.svg"
import email from "../../assets/email.svg"
import { useHistory } from "react-router";
import logo from "../../assets/logo.svg"
import menu from "../../assets/menu.svg"






const Navbar = ({ setIsMenuOpen }) => {
    const company = useSelector((state) => state.companyData.company);
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const history = useHistory()
    const pages = [
        {
            "href": "/",
            "title": "home"
        },
        {
            "href": "/about",
            "title": "about"
        }, {
            "href": "/menu",
            "title": "menus"
        }, {
            "href": "/gallery",
            "title": "gallery"
        }, {
            "href": "/contact",
            "title": "contact"
        }
    ]
    const getPages = () => {
        let array = []
        for (let index = 0; index < pages.length; index += 3) {
            array.push(pages.slice(index, index + 3))

        }
        return array
    }
    return (
        <div className="SuvaiNavbar">
            <div className="SuvaiNavbar-top">
                <div className="SuvaiNavbar-top-left">
                    <div className="SuvaiNavbar-top-left-item">
                        <img alt="" src={pin} />
                        {companyDetails?.address?.city}, {companyDetails?.address?.postcode}, {companyDetails?.address?.state}
                    </div>
                    <div className="SuvaiNavbar-top-left-item">
                        <img alt="" src={phone} />
                        {companyDetails?.contactNumber}   </div>
                    <div className="SuvaiNavbar-top-left-item">
                        <img alt="" src={email} />
                        {companyDetails?.email}
                    </div>
                </div>
                <div className="SuvaiNavbar-top-right">
                    {company?.SocialMedias
                        ?.instagram && company?.SocialMedias
                            ?.instagram !== "" && <div
                                onClick={() => {
                                    window.open(company?.SocialMedias
                                        ?.instagram, '_blank')
                                }}
                                className="SuvaiNavbar-social">
                            <img alt="" src={insta} />
                        </div>}
                    {company?.SocialMedias
                        ?.facebook && company?.SocialMedias
                            ?.facebook !== "" &&
                        <div className="SuvaiNavbar-social"
                            onClick={() => {
                                window.open(company?.SocialMedias
                                    ?.facebook, '_blank')
                            }} >
                            <img alt="" src={fb} />
                        </div>}

                    {company?.SocialMedias
                        ?.tiktok && company?.SocialMedias
                            ?.tiktok !== "" && <div className="SuvaiNavbar-social"
                                onClick={() => {
                                    window.open(company?.SocialMedias
                                        ?.tiktok, '_blank')
                                }}>
                            <img alt="" src={tt} />
                        </div>}
                </div>
                <img alt="" src={menu} className="SuvaiNavbar-top-mobile"
                    onClick={() => {
                        setIsMenuOpen(true)
                    }} />

            </div>
            <div className="SuvaiNavbar-navs">
                <img alt="" src={logo} className="SuvaiNavbar-logo" />
                {getPages().map((pageW, index) => (
                    <div className="SuvaiNavbar-navs-tab" key={index}>
                        {pageW.map((page) => {
                            return (
                                <div
                                    className={`SuvaiNavbar-navs-tab-title  ${window.location.pathname === page?.href ? "selected" : ""}`}
                                    key={page.title}
                                    onClick={() => {
                                        if (page?.href?.includes("https://")) {
                                            if (page?.href && page?.href !== "") {
                                                window.open(page?.href, '_blank')
                                            }
                                        } else {
                                            history.push(page?.href)
                                        }
                                    }}>{page.title}</div>
                            )
                        })}
                        {index === getPages().length - 1 &&
                            <div className={`SuvaiNavbar-navs-tab-button `}>Book a table</div>}
                    </div>
                ))}


            </div>

        </div>
    )
}
export default Navbar